import { get2 } from "@/shared/axios";
import useFranchiseHook from "@/shared/hooks/useFranchiseHook";
import { useQuery } from "@tanstack/react-query";

const usePrimaryHostnameQuery = () => {
  const [franchise] = useFranchiseHook();
  const queryFn = ["primary-hostname", franchise];
  const query = useQuery<string>({
    queryKey: queryFn,
    queryFn: () => get2(`internal/anonymous/websites/v3/base/url/${franchise}`),
  });

  return query;
};

export default usePrimaryHostnameQuery;
